import React, { useState } from 'react';
import {urlApiProd,dialogTemplate,print} from '../utiles';
import DateInput from '../../components/DateInput/DateInput';
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal, Button, Spinner, Badge } from 'react-bootstrap';


const ModificarSolicitudInterna = ({ solicitud, puertos, clientes, cerrar }) => {

    const [formData, setFormData] = useState({
        codigo: solicitud.codigo,
        id_cliente: solicitud.id_cliente ?? '',
        id_puerto_destino: solicitud.id_puerto_destino,
        freetimedestino: solicitud.freetimedestino,
        etd: solicitud.etd,
        cantidad: solicitud.cantidad,
        requerimientos: solicitud.requerimientos,
        id_solicitudinterna : solicitud.id_solicitudinterna,
        estado: solicitud.estado,
        tipo_bl : solicitud.tipo_bl,
        cantidad_solicitada: solicitud.cantidad_solicitada,
        cantidad_confirmada : solicitud.cantidad_confirmada,
    });

    const [currentRadioValue, setCurrentValue] = React.useState(solicitud.tipo_bl);
    const [showSoli, setShowSoli] = React.useState(true);
    const clienteInicial = clientes.find(cliente => Number(cliente.id_cliente) === Number(solicitud.id_cliente));
    const [clienteNombre, setClienteNombre] = useState(clienteInicial?.nombre || '');
    const [clientesDropdownAbierto, setClientesDropdownAbierto] = useState(false);
    
        const handleCloseSoli = () => {setShowSoli(false);
            cerrar();
        };
    
    

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleChangeUpperCase = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value.toUpperCase() });
    };

    const handleClienteChange = (e) => {
        const nombre = e.target.value;
        setClienteNombre(nombre);
        setClientesDropdownAbierto(true);
        setFormData(prev => ({ ...prev, id_cliente: '' }));
    };

    const seleccionarCliente = (cliente) => {
        setClienteNombre(cliente.nombre);
        setFormData(prev => ({ ...prev, id_cliente: cliente.id_cliente }));
        setClientesDropdownAbierto(false);
    };

    const clientesFiltrados = clientes.filter(cliente =>
        cliente.nombre.toLocaleLowerCase().includes(clienteNombre.trim().toLocaleLowerCase())
    ).slice(0, 50);

    const handleClienteKeyDown = (e) => {
        if (e.key === 'Escape') {
            setClientesDropdownAbierto(false);
        } else if (e.key === 'Enter' && clientesDropdownAbierto && clientesFiltrados.length > 0) {
            e.preventDefault();
            seleccionarCliente(clientesFiltrados[0]);
        }
    };

    const handleRadioChange = value1 => {
        const { name, value } = value1.target;
        setFormData({ ...formData, [name]: value });
      };

    const handleSubmit = async () => {
        //e.preventDefault();

        if (!formData.id_cliente) {
            alert('Seleccione un cliente de la lista');
            return;
        }

        const token = localStorage.getItem('token');

        try {
            const response = await fetch(`${urlApiProd}/modificarsolicitudinterna`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(formData)
            });
            if (!response.ok) throw new Error('Error al modificar la solicitud interna');
            alert('Solicitud interna modificada exitosamente');
            cerrar();
        } catch (error) {
            console.error('Error:', error);
            alert('No se pudo modificar la solicitud interna');
        }
    };


    const CancelarBooking = () =>  {
        const [show, setShow] = React.useState(false);
      
        const handleClose = () => setShow(false);
        const handleShow = () => {
            //console.error('formData.estado:', formData.estado);
            if(formData.estado.toString()==="-1"){
            setShow(true);}
            else{
            handleSubmit();
        }
        };

        const handleCloseCancelar = () => {
            setShow(false);

        };
      
        return (
          <>
            <Button variant="primary" onClick={handleShow}>
              Guardar
            </Button>
      
            <Modal show={show} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>¿Seguro de cancelar?</Modal.Title>
              </Modal.Header>
              <Modal.Body>
              Al aceptar la solicitud interna quedará en estado cancelada.           
              </Modal.Body>
              <Modal.Footer>
              <Button variant="primary" onClick={handleSubmit}>
              Aceptar
               </Button>
                <Button variant="outline-secondary" onClick={handleClose}>
                  Volver
                  </Button>
              </Modal.Footer>
            </Modal>

          </>
        );
      };

    return (
        <Modal show={showSoli} onHide={handleCloseSoli} backdrop="static">
              <Modal.Header closeButton>
                <Modal.Title>Modificar Solicitud Interna</Modal.Title>
              </Modal.Header>
              <Modal.Body>
              <form onSubmit={handleSubmit}>
                            <div className="mb-3 position-relative">
                                <label className="form-label" htmlFor="cliente-modificar-solicitud-interna">Cliente</label>
                                <input
                                    id="cliente-modificar-solicitud-interna"
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    placeholder="Buscar cliente..."
                                    value={clienteNombre}
                                    onChange={handleClienteChange}
                                    onFocus={() => setClientesDropdownAbierto(true)}
                                    onBlur={() => setTimeout(() => setClientesDropdownAbierto(false), 150)}
                                    onKeyDown={handleClienteKeyDown}
                                    role="combobox"
                                    aria-autocomplete="list"
                                    aria-expanded={clientesDropdownAbierto}
                                    aria-controls="clientes-modificar-solicitud-interna"
                                    required
                                />
                                {clientesDropdownAbierto && (
                                    <div
                                        id="clientes-modificar-solicitud-interna"
                                        className="list-group position-absolute w-100 shadow"
                                        role="listbox"
                                        style={{ top: 'calc(100% + 2px)', left: 0, maxHeight: 220, overflowY: 'auto', zIndex: 1060 }}
                                    >
                                        {clientesFiltrados.length > 0 ? clientesFiltrados.map(cliente => (
                                            <button
                                                key={cliente.id_cliente}
                                                type="button"
                                                className="list-group-item list-group-item-action text-start"
                                                role="option"
                                                onMouseDown={e => e.preventDefault()}
                                                onClick={() => seleccionarCliente(cliente)}
                                            >
                                                {cliente.nombre}
                                            </button>
                                        )) : (
                                            <div className="list-group-item text-muted">No se encontraron clientes</div>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Código</label>
                                <input type="text" className="form-control" name="codigo" onChange={handleChangeUpperCase} value={formData.codigo} disabled/>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Puerto Destino</label>
                                <select
                                    className="form-select"
                                    name="id_puerto_destino"
                                    onChange={handleChange}
                                    value={formData.id_puerto_destino}
                                >
                                    <option value="">Seleccione un Puerto</option>
                                    {puertos
                                        .filter((puerto) => puerto.indicador === 2 || puerto.indicador === 3) // Filtra puertos destino
                                        .map((item) => (
                                            <option key={item.id_puerto} value={item.id_puerto}>
                                                {item.nombre}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">ETD</label>
                                <DateInput name="etd" onChange={handleChange} value={formData.etd} required />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Free Time Destino</label>
                                <input type="text" className="form-control" name="freetimedestino" onChange={handleChange} value={formData.freetimedestino} required />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Cantidad de Contenedores</label>
                                <input type="number" className="form-control" name="cantidad" onChange={handleChange} value={formData.cantidad} required />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Requerimientos Especiales</label>
                                <textarea className="form-control" name="requerimientos" onChange={handleChange} value={formData.requerimientos}></textarea>
                            </div>
                            <div className="radio-buttons">
                                <input type="radio" value="BL Original" name="tipo_bl" onChange={handleRadioChange} defaultChecked={currentRadioValue === 'BL Original'}/> BL Original
                                <input style={{ marginLeft: '25px' }} type="radio" value="Express Release" name="tipo_bl" onChange={handleRadioChange} defaultChecked={currentRadioValue === 'Express Release'}/> Express Release
                            </div>
                            <br></br>
                            <div className="mb-3">
                                <label className="form-label">Estado</label>
                                <select
                                    className="form-select"
                                    name="estado"
                                    onChange={handleChange}
                                    value={formData.estado}
                                >
                                    <option value="">Seleccione un estado</option>
                                    {[{id : 0, estado:"Pendiente"},{id : 1, estado:"Solicitado"},{id : -1, estado:"Cancelado"},].map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.estado}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            <div className="modal-footer">
                                <Button variant="secondary" type="button" onClick={handleCloseSoli}>
                                    Volver
                                </Button>
                                <CancelarBooking />
                            </div>
                        </form>
              </Modal.Body>
            </Modal>
    );
}

export default ModificarSolicitudInterna;
        
